import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
// import Login from './views/Login.vue'
import About from './views/About.vue'
import course from './views/course.vue'
import teacher from './views/teacher.vue'
import jobFair from './views/jobFair.vue'
import jobDetail from './views/jobDetail.vue'
import photoAlbum from './views/photoAlbum.vue'
import dynamic from './views/dynamic.vue'
import dynamicDetail from './views/dynamicDetail.vue'
import InfoDetails from './views/InfoDetails.vue'
import previewPdf from './views/previewPdf.vue'
import previewImg from './views/previewImg.vue'
Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/photoAlbum',
      name: 'photoAlbum',
      component: photoAlbum
    },
    {
      path: '/jobFair',
      name: 'jobFair',
      component: jobFair
    },
    {
      path: '/jobDetail',
      name: 'jobDetail',
      component: jobDetail
    },
    {
      path: '/teacher',
      name: 'teacher',
      component: teacher
    },
    {
      path: '/course',
      name: 'course',
      component: course
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/dynamic',
      name: 'dynamic',
      component: dynamic
    },
    {
      path: '/dynamic_detail',
      name: 'dynamic_detail',
      component: dynamicDetail
    },
    {
      path: '/InfoDetails',
      name: 'InfoDetails',
      component: InfoDetails,
      meta: { title: "资料详情" },
    },
    {
      path: '/previewPdf',
      name: 'previewPdf',
      component: previewPdf,
      meta: { title: "资料详情" },
    },
    {
      path: '/previewImg',
      name: 'previewImg',
      component: previewImg,
      meta: { title: "资料详情" },
    },
  ]
})
